import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./installations/routes/AppRoutingProvider";
import HeaderComponent from "./components/layouts/header/HeaderComponent";
// import FooterComponent from "./components/layouts/footer/FooterComponent";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DialogManagerComponent from "./components/dialogs/DialogManagerComponent";
import FooterComponent from "./components/layouts/footer/FooterComponent";
import { queryClient } from "./middlewares/cacheing/QueryClient.middleware";
import ScrollToTop from "./hooks/useScrollToTop";
import AppBootstrap from "./components/bootstrap/AppBootstrap";
import SelectedCustomerBarComponent from "./components/layouts/selectedCustomerBar/SelectedCustomerBarComponent";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* 0015: single fetch of UserInfo/categories/websiteConfiguration, bridged into Redux. */}
      <AppBootstrap />
      <div className="appLayoutContainer">
        {/* 0017: persistent on-behalf customer bar above the header (Admin/Agent only). */}
        <SelectedCustomerBarComponent />
        <HeaderComponent />
        <div className="container">
          <ScrollToTop /> {/* Ensures all page changes scroll to top */}
          <AppRoutes />
        </div>
        <FooterComponent />
      </div>
      <DialogManagerComponent />
    </QueryClientProvider>
  );
}

export default App;
